import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import AnimatedSection from "@/components/AnimatedSection";
import TextReveal from "@/components/TextReveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export interface FAQ {
  id: string;
  question: string;
  answer: string;
}

export const useFAQs = () => {
  const [faqs, setFaqs] = useState<FAQ[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFAQs = async () => {
      const { data } = await supabase
        .from("faqs")
        .select("id, question, answer")
        .eq("published", true)
        .order("display_order", { ascending: true });
      if (data) setFaqs(data);
      setLoading(false);
    };
    fetchFAQs();
  }, []);

  return { faqs, loading };
};

const FAQSection = () => {
  const { faqs, loading } = useFAQs();

  if (loading || faqs.length === 0) return null;

  return (
    <section id="faq" className="py-20 md:py-28">
      <div className="container max-w-3xl">
        <AnimatedSection direction="none" scale className="text-center mb-12">
          <p className="text-xs font-body uppercase tracking-[0.3em] text-muted-foreground mb-4">
            FAQ
          </p>
          <TextReveal>
            <h2 className="font-heading text-3xl md:text-4xl font-light">
              Questions fréquentes
            </h2>
          </TextReveal>
        </AnimatedSection>

        <AnimatedSection delay={0.2}>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq) => (
              <AccordionItem key={faq.id} value={faq.id}>
                <AccordionTrigger className="text-left font-heading text-base md:text-lg font-normal hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-body leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default FAQSection;
